import React from 'react'
import Camera, { FACING_MODES, IMAGE_TYPES } from 'react-html5-camera-photo'
import 'react-html5-camera-photo/build/css/index.css'
import Typography from '@material-ui/core/Typography'
import CardActions from '@material-ui/core/CardActions'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import Avatar from '@material-ui/core/Avatar'
import CardContent from '@material-ui/core/CardContent'
import Fab from '@material-ui/core/Fab'
import CircularProgress from '@material-ui/core/CircularProgress'
import CardMedia from '@material-ui/core/CardMedia'

import CameraIcon from '@material-ui/icons/CameraAlt'
import ScreenRotationIcon from '@material-ui/icons/ScreenRotation'
import isMobile from 'is-mobile'
import imageCompression from 'browser-image-compression'
import MyCheckmark from './MyCheckmark'
import PropTypes from 'prop-types'
import convertFileToBase64 from '../helpers/convertFileToBase64'
import './ScanLicense.css'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import RepeatIcon from '@material-ui/icons/Repeat'
import { withTranslation } from 'react-i18next'

class ScanLicense extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      flipped: false,
      isCameraOn: false,
      frontPic: null,
      backPic: null,
      submitting: false,
      isCameraAllowed: true
    }
  }
  onTakePhoto(dataUri) {
    // console.log(dataUri)
  }

  onCameraError(error) {
    // if (this.state.isCameraAllowed) {
    //   this.setState({ isCameraAllowed: false })
    // }
    console.error('onCameraError', error)
  }

  handleTakePhoto = () => {
    const cameraComponentButton = document.getElementById('outer-circle')
    if (cameraComponentButton) {
      cameraComponentButton.click()
    }
  }

  renderCamera(direction) {
    const photo = this.state[`${direction}Pic`]
    const { isCameraOn } = this.state
    const currentSide = this.state.flipped ? 'back' : 'front'
    let camstate = photo !== null ? 'showPhoto' : isCameraOn ? 'showCamera' : 'showDefault'
    if (direction !== currentSide) {
      camstate = 'showDefault'
    }
    let heightParam = '56.25%'

    const idealResolution = isMobile() ? { width: '100%', height: '100%' } : { width: 1920, height: 1080 }

    return (
      <div className="container-sm-max">
        <div
          style={{
            position: 'relative',
            boxSizing: 'border-box',
            height: '100%',
            paddingBottom: heightParam,
            paddingTop: 0,
            width: '100%',
            overflow: 'hidden'
          }}
        >
          {camstate === 'showPhoto' && (
            <div className="flex-center" style={{ height: 'auto' }}>
              {/* <img style={{ transform: imageTransform }} alt="Captured License" src={photo || undefined} /> */}
              <figure>
                <img alt="Captured License" style={{ height: '100%' }} src={photo || undefined} />
              </figure>
              <MyCheckmark style={{ width: '40%', position: 'absolute' }} />

              <div
                style={{
                  boxSizing: 'border-box',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  margin: '2rem',
                  border: '2px dashed #FFFFFF',
                  borderRadius: '8px'
                }}
              />
            </div>
          )}
          {camstate === 'showCamera' && (
            <div className="fill-all-absolute">
              <Camera
                onTakePhoto={(dataUri) => {
                  this.setState({ [`${direction}Pic`]: dataUri })
                }}
                onCameraError={(error) => {
                  this.onCameraError(error)
                }}
                idealFacingMode={FACING_MODES.ENVIRONMENT}
                idealResolution={idealResolution}
                imageType={IMAGE_TYPES.JPG}
                imageCompression={0.9}
                isMaxResolution={false}
                isImageMirror={false}
                isSilentMode
                isDisplayStartCameraError={false}
                isFullscreen={false}
                sizeFactor={1}
              />
              <div
                style={{
                  boxSizing: 'border-box',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  margin: '2rem',
                  border: '2px dashed #FFFFFF',
                  borderRadius: '8px'
                }}
              >
                <Typography
                  variant="body1"
                  style={{ color: 'white', textShadow: '2px 2px 4px rgba(0,0,0,0.6)', padding: '1rem' }}
                >
                  Center {direction} of Driver's License here
                </Typography>
              </div>
              <div className="camera-fab-wrapper">
                <Fab className="camera-fab" onClick={() => this.handleTakePhoto()}>
                  <CameraIcon />
                </Fab>
              </div>
            </div>
          )}
          {camstate === 'showDefault' && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: '#555',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column'
              }}
            >
              {isMobile() ? (
                <>
                  <input
                    type="file"
                    id={`${direction}-camera`}
                    accept=".png, .jpg, .jpeg"
                    capture="environment"
                    style={{ height: '0.1px', width: '0.1px' }}
                    onChange={async (event) => {
                      if (event.target.files.length > 0) {
                        const compressedFile = await imageCompression(event.target.files[0], {
                          maxSizeMB: 0.2,
                          maxWidthOrHeight: 800,
                          initialQuality: 0.8
                        })
                        const dataUri = await convertFileToBase64(compressedFile)
                        // console.log(dataUri) - it overwhelms console output
                        this.setState({ [`${this.state.flipped ? 'back' : 'front'}Pic`]: dataUri })
                      }
                    }}
                  />
                  <label htmlFor={`${direction}-camera`} style={{ zIndex: '4', textAlign: 'center' }}>
                    <Fab component="div">
                      <CameraIcon />
                    </Fab>
                    <Typography
                      variant="body1"
                      style={{ color: 'white', marginTop: '0.5rem', textShadow: '2px 2px 4px rgba(0,0,0,0.4)' }}
                    >
                      Start Camera
                    </Typography>
                  </label>
                </>
              ) : (
                <>
                  <Fab
                    style={{ zIndex: '3' }}
                    onClick={() => {
                      this.setState({ isCameraOn: true })
                    }}
                  >
                    <CameraIcon />
                  </Fab>
                  <Typography
                    variant="body1"
                    style={{ color: 'white', marginTop: '0.5rem', textShadow: '2px 2px 4px rgba(0,0,0,0.4)' }}
                  >
                    Start Camera
                  </Typography>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }

  render() {
    const { t } = this.props
    if (this.props.snapshot && this.state.frontPic) {
      return (
        <div className="center">
          <img style={{ maxWidth: 600 }} alt="" src={this.state.frontPic} />
        </div>
      )
    }
    return (
      <div
        className="container-sm-max"
        style={{
          position: 'relative',
          maxWidth: Math.min(window.innerWidth, 600),
          perspective: 1000,
          marginBottom: '2rem'
        }}
      >
        {/* {!this.state.isCameraAllowed && (
          <SnackbarContent
            style={{ backgroundColor: '#f44336' }}
            aria-describedby="client-snackbar"
            message={
              <span id="client-snackbar">
                <Typography variant="subtitle1" style={{ color: '#FFFFFF' }}>
                  <ErrorIcon className="center" style={{ verticalAlign: 'middle' }} />
                  &nbsp;CameraError
                </Typography>
                <Typography style={{ color: '#FFFFFF' }}>
                  We were unable to access your camera. For help checking permissions settings, check our troubleshooting
                  guide.
                </Typography>
              </span>
            }
          />
        )} */}

        <div className="mb-1" />
        <div>
          <Card className="container-sm-max card-front">
            <CardHeader
              title={
                <div>
                  <Typography variant="h5">{t(this.props.waiverModelScan.scanDriverLicense)}</Typography>
                </div>
              }
              avatar={
                <Avatar>
                  <CameraIcon />
                </Avatar>
              }
              // action={
              //   <IconButton>
              //     <MoreVertIcon />
              //   </IconButton>
              // }
            />
            <CardMedia style={{ height: 250 }} image="img/phone-scan.png" title="License" />
            {this.state.submitting ? (
              <CircularProgress style={{ margin: 'auto', display: 'flex' }} />
            ) : (
              <>
                <CardContent style={{ margin: 0, padding: 0 }}>{this.renderCamera('front')}</CardContent>

                <CardActions style={{ flex: 1 }}>
                  <div style={{ flex: 1 }} />
                  {this.state.frontPic ? (
                    <>
                      <Fab className="fab-wrapper" variant="extended" onClick={() => this.setState({ frontPic: null })}>
                        <RepeatIcon />
                        {t('retake')}
                      </Fab>
                      <Fab
                        className="fab-wrapper"
                        color="primary"
                        variant="extended"
                        onClick={() => {
                          this.setState({ submitting: true })
                          this.props.onComplete(this.state.frontPic)
                        }}
                      >
                        Ok
                        <NavigateNextIcon />
                      </Fab>
                    </>
                  ) : (
                    <Fab variant="extended" color="primary" onClick={() => this.props.onSkip()}>
                      {t('noThanks')}
                      <NavigateNextIcon />
                    </Fab>
                  )}
                </CardActions>
              </>
            )}
            <CardContent>
              <Typography component="p" className="center">
                <ScreenRotationIcon className="center" style={{ verticalAlign: 'middle' }} />
                &nbsp;{t(this.props.waiverModelScan.holdPhoneText)}
              </Typography>

              <Typography component="p" className="center">
                {t(this.props.waiverModelScan.centerFrontLicenseText)}
              </Typography>
            </CardContent>
          </Card>
        </div>
      </div>
    )
  }
}

ScanLicense.propTypes = {
  onSkip: PropTypes.func,
  onComplete: PropTypes.func,
  snapshot: PropTypes.bool,
  waiverModelScan: PropTypes.any,
  t: PropTypes.any
}

export default withTranslation()(ScanLicense)
